var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',_vm._l((_vm.icons),function(icon,i){return _c('v-btn',{key:i,staticClass:"white--text",attrs:{"href":icon.link,"target":"_blank","icon":""}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v(_vm._s(icon.text))])],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }